module.exports = __webpack_public_path__ + "static/media/notelehealthservicesicon.4839d16b.svg";